angular
  .module 'shared'
  .factory 'PeriodicalUnits', ->
    days: 'daily'
    weeks: 'weekly'
    months: 'monthly'
    years: 'yearly'
